import React from 'react';
import LinkTableCell from '@components/Kendo/LinkTableCell';
function DeficiencyIdCell({ colSpan, dataItem, field = '', className = '', ariaColumnIndex, style = null, onDeficiencyClick }) {
    if (!onDeficiencyClick) {
        return (React.createElement(LinkTableCell, { colSpan: colSpan, dataItem: dataItem, field: field, className: className, ariaColumnIndex: ariaColumnIndex, style: style }));
    }
    return (React.createElement("td", { colSpan: colSpan, className: className, role: "gridcell", "aria-colindex": ariaColumnIndex, style: style || undefined },
        React.createElement("a", { href: dataItem.idPath, "data-testid": `deficiency-id-link-${dataItem.id}`, onClick: (event) => {
                event.preventDefault();
                onDeficiencyClick(dataItem.id);
            } }, dataItem.id)));
}
export default DeficiencyIdCell;
